import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TSliceInitialState, useAppSelector } from '../../hooks';
import { TAccountClient, TAccountClientResponse, adaptAccountClientFromResponse } from '../../types';
import { BACKEND_ACCOUNT_CLIENT } from '../../backend-paths';


export const accountClientReadGetApi = createAsyncThunk(
	`FETCH/${BACKEND_ACCOUNT_CLIENT}/:id`,
	(payload: number, thunkApi) => {
		const path = `${BACKEND_ACCOUNT_CLIENT}/${payload}`;

		return HttpService.get<TAccountClientResponse>(path).then(result => {
			return adaptAccountClientFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TAccountClient> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const accountClientReadSlice = createSlice({
	name: 'accountClientReadSlice',
	initialState,
	reducers: {
		setAccountClientRead(state, action: PayloadAction<TAccountClient>) {
			state.item = action.payload;
		},

		clearAccountClientRead(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[accountClientReadGetApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[accountClientReadGetApi.fulfilled.type]: (state, action: PayloadAction<TAccountClient>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[accountClientReadGetApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useAccountClientReadSelector = () => useAppSelector(state => state[accountClientReadSlice.name]);

export const { clearAccountClientRead, setAccountClientRead } = accountClientReadSlice.actions;
